import {
  ICellRendererParams,
  ProcessCellForExportParams,
  ValueFormatterParams,
} from 'ag-grid-community'

export const dateFormatter = (
  params:
    | ValueFormatterParams
    | ProcessCellForExportParams
    | ICellRendererParams
) => {
  if (params?.value) {
    return params.value.split('T')[0]
  }
  return ''
}
